var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 43.4,
    cy: 15.4,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,132.4c-0.7,2.8,0.9,5.6,3.6,6.3s5.6-0.9,6.3-3.6L44,74.6H33.4L17.9,132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,74.6H46l16.2,60.5c0.7,2.8,3.6,4.4,6.3,3.6c2.8-0.7,4.4-3.6,3.6-6.3L56.6,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,28.5c-0.3-9.6-1.4-19.1-3.4-28.4h-2.8c2,9.3,3.2,18.7,3.5,28.3H18c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1h15.4v30.9 h23.1V38.6h39.7c-0.6,19.4-4.8,38.2-12.3,56l2.5,1.1c7.7-18.2,11.9-37.4,12.5-57.3c2.2-0.6,3.9-2.6,3.9-5 C102.9,31,101.2,29,99,28.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchery);
export default __webpack_public_path__ + "static/media/archery.ffabb474a945cf022b7c0226e31b0be7.svg";
export { ForwardRef as ReactComponent };